import {city} from "ca-plateform-delivery-api-domain";
import {buildTourApiUrl} from "api/configuration";
import {http} from "api/http";

export interface DeliveryCsvScan extends city.colisactiv.delivery.api.model.DeliveryCsvScan {}
export interface DeliveryCsvScannerResult extends city.colisactiv.delivery.api.model.DeliveryCsvScannerResult {}
export interface DeliveryCsvLineError extends city.colisactiv.delivery.api.model.DeliveryCsvLineError {}
export interface DeliveryCsvBonusOverview extends city.colisactiv.delivery.api.model.DeliveryCsvBonusOverview {}

export const scanCsv = (
  organizationId: string,
  file: ArrayBuffer,
  skipDuplicateCheck: boolean = false
): Promise<DeliveryCsvScan> => {
  const url = buildTourApiUrl(
    `/deliverytours/organization/${organizationId}/scanCsv?skipDuplicateCheck=${skipDuplicateCheck}`
  );
  return http.postCsv(url, file);
};
